<template>
  <div class="partners-page">
    <!-- Editorial Hero -->
    <section class="ahrs-page-hero hero-photo-partners">
      <div class="ahrs-page-hero-wrap">
        <div class="ahrs-page-eyebrow" data-aos="fade-up">
          <span class="dot"></span>Partners &amp; Supporters
        </div>
        <h1 class="ahrs-page-title" data-aos="fade-up" data-aos-delay="100">
          Backed by
          <span class="ahrs-page-italic">21+ partner associations.</span>
        </h1>
        <p class="ahrs-page-lede" data-aos="fade-up" data-aos-delay="200">
          AHRS 2026 is proudly supported by leading HR associations,
          professional bodies, and government institutions from across Africa
          and beyond.
        </p>
      </div>
    </section>

    <!-- Partners Grid -->
    <section class="partners-main-section">
      <div class="container-wide">
        <h2 class="section-title" data-aos="fade-up">Partner Organizations</h2>
        <p class="section-subtitle" data-aos="fade-up" data-aos-delay="100">
          Together, we are shaping the future of human resource management
          across the African continent.
        </p>

        <div class="partners-logo-grid" data-aos="fade-up" data-aos-delay="200">
          <div
            v-for="partner in partners"
            :key="partner.name"
            :class="['partner-logo-card', { 'logo-green-bg': partner.greenBg }]"
            data-aos="zoom-in"
            :data-aos-delay="partner.delay"
          >
            <div
              :class="[
                'logo-wrapper',
                { 'logo-wrapper-green': partner.greenBg },
              ]"
            >
              <img
                :src="partner.logo"
                :alt="partner.name"
                class="partner-logo-img"
              />
            </div>
            <div class="partner-info">
              <span class="partner-name">{{ partner.name }}</span>
              <span class="partner-region">{{ partner.region }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PartnersView",
  data() {
    return {
      partners: [
        {
          name: "United Republic of Tanzania",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/United_Republic_of_Tanzania-removebg-preview.png"),
          delay: "100",
        },
        {
          name: "Government of Zanzibar",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/Govt_of_Zanzibar-removebg-preview.png"),
          delay: "150",
        },
        {
          name: "African Human Resource Confederation(AHRC)",
          region: "International",
          logo: require("@/assets/images/partners logos/African Human Resource Confederation (AHRC).png"),
          delay: "200",
        },
        {
          name: "World Federation of People Management Association",
          region: "International",
          logo: require("@/assets/images/partners logos/World Federation of People Management Association.png"),
          delay: "250",
        },
        {
          name: "World Employment Confederation",
          region: "International",
          logo: require("@/assets/images/partners logos/World_Employment_Confederation-removebg-preview.png"),
          delay: "300",
        },
        {
          name: "Ordre National des Professionnels en Gestion des Ressources Humaines",
          region: "DR Congo",
          logo: require("@/assets/images/partners logos/Ordre National des Professionnels en Gestion des Ressources Humaines (ONPGRH-DRC).png"),
          delay: "350",
        },
        {
          name: "Tanzania Human Resource And Administration Proffesional Assosiation",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/THRAPA.png"),
          delay: "400",
        },
        {
          name: "Institute of Personnel Management – Eswatini",
          region: "Eswatini",
          logo: require("@/assets/images/partners logos/Institute of Personnel Management – Swaziland.png"),
          delay: "450",
        },
        {
          name: "Society for Human Resource Management (SHRM)",
          region: "International",
          logo: require("@/assets/images/partners logos/Society for Human Resource Management (SHRM).png"),
          delay: "500",
        },
        {
          name: "Institute of People Management",
          region: "South Africa",
          logo: require("@/assets/images/partners logos/Institute_of_People_Management__IPM___South_Africa-removebg-preview.png"),
          delay: "550",
        },
        {
          name: "South Africa Association of Public Administration (SAAPAM)",
          region: "South Africa",
          logo: require("@/assets/images/partners logos/South Africa Association of Public Administration (SAAPAM).png"),
          delay: "600",
        },
        {
          name: "Institute of Human Resource Management",
          region: "Kenya",
          logo: require("@/assets/images/partners logos/Institute of Human Resource Management - Kenya.png"),
          delay: "650",
        },
        {
          name: "Chartered Institute of Human Resource Management",
          region: "Ghana",
          logo: require("@/assets/images/partners logos/chartered_institute_of_human_ghana-removebg-preview.png"),
          delay: "700",
        },
        {
          name: "HR Professionals Society - Botswana",
          region: "Botswana",
          logo: require("@/assets/images/partners logos/Human Resources Professionals Society - Botswana (HRPSB).png"),
          delay: "750",
        },
        {
          name: "Institute of People Management - Malawi",
          region: "Malawi",
          logo: require("@/assets/images/partners logos/Institute_of_People_Management__Malawi_-removebg-preview.png"),
          delay: "800",
        },
       {
          name: "HR Managers' Association of Uganda",
          region: "Uganda",
          logo: require("@/assets/images/partners logos/Human Resource Managers Association of Uganda (HRMAU).png"),
          delay: "850",
        },
        {
          name: "Rwanda HR Management Organisation",
          region: "Rwanda",
          logo: require("@/assets/images/partners logos/Rwanda Human Resource Management organization (RHRMO).png"),
          delay: "900",
        },
        {
          name: "ASPRH - Association Sénégalaise des Professionnels des RH",
          region: "Senegal",
          logo: require("@/assets/images/partners logos/ASPRH - Association Sénégalaise des Professionnels des RH.png"),
          delay: "950",
        },
        {
          name: "Chartered Institute of Personnel Management of Nigeria",
          region: "Nigeria",
          logo: require("@/assets/images/partners logos/Chartered_Institute_of_Personnel_Management_of_Nigeria__CIPMN_-removebg-preview.png"),
          delay: "1000",
        },
        {
          name: "South Sudan Human Resource Society",
          region: "South Sudan",
          logo: require("@/assets/images/partners logos/South_Sudan_Human_Resource_Society__SSHRS_-removebg-preview.png"),
          delay: "1050",
        },
        {
          name: "American international certification institute",
          region: "America",
          logo: require("@/assets/images/partners logos/American international certification institute.png"),
          delay: "1100",
        },
        {
          name: "Institute of Personnel Management of Zimbabwe",
          region: "Zimbabwe",
          logo: require("@/assets/images/partners logos/Institute of Personnel Management of Zimbabwe (IPMZ).png"),
          delay: "1150",
        },

        {
          name: "Institute of Public Administration",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/Institute_of_Public_Administration__IPA_-removebg-preview.png"),
          delay: "1200",
        },
        {
          name: "Occupational Safety and Health Authority",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/OSHA.png"),
          delay: "1250",
        },
        {
          name: "Association Africaine des Formateurs et Directeurs de Personne",
          region: "Tanzania",
          logo: require("@/assets/images/partners logos/Association Africaine des Formateurs et Directeurs de Personne.png"),
          delay: "1300",
        },
        {
          name: "Somali Human Resource Society",
          region: "Somalia",
          logo: require("@/assets/images/partners logos/Somali Human Resource Society (SHRS).png"),
          delay: "1350",
          greenBg: true,
        },
        {
          name: "Institute of People Management – Namibia",
          region: "Namibia",
          logo: require("@/assets/images/partners logos/Institute of People Management - Namibia.png"),
          delay: "1400",
          greenBg: true,
        },
        {
          name: "Institute of People Management – Zambia",
          region: "Zambia",
          logo: require("@/assets/images/partners logos/Institute of People Management - Zambia.png"),
          delay: "1450",
          greenBg: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Editorial hero backdrop photo */
.hero-photo-partners {
  --hero-photo: url("~@/assets/images/past Ahrs/mass.jpg");
}

/* ── Hero ─────────────────────────────────────────── */
.partners-hero {
  position: relative;
  min-height: 420px;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 100px 0 60px;
}

.hero-background {
  position: absolute;
  inset: 0;
  background: var(--gradient-hero);
  z-index: 0;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

.floating-shapes {
  position: absolute;
  inset: 0;
  overflow: hidden;
}
.shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
  background: var(--color-accent);
}
.shape-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
}
.shape-2 {
  width: 250px;
  height: 250px;
  bottom: -50px;
  left: 10%;
}
.shape-3 {
  width: 150px;
  height: 150px;
  top: 40%;
  left: 60%;
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 760px;
  margin: 0 auto;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  padding: 10px 24px;
  margin-bottom: 24px;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 500;
}

.badge-icon {
  font-size: 1rem;
  color: var(--color-accent);
}

.hero-title {
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  margin: 0;
}

/* ── Partners Section ─────────────────────────────── */
.partners-main-section {
  padding: 80px 0 100px;
  background: var(--gradient-section);
}

.section-title {
  text-align: center;
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 700;
  color: var(--color-primary-dark);
  margin-bottom: 16px;
}

.section-subtitle {
  text-align: center;
  color: var(--color-text-secondary);
  font-size: 1.05rem;
  max-width: 640px;
  margin: 0 auto 60px;
  line-height: 1.7;
}

/* ── Logo Grid ────────────────────────────────────── */
.partners-logo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 28px;
}

.partner-logo-card {
  background: #fff;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  padding: 28px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  border: 1px solid var(--color-background-light);
}

.partner-logo-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-lg);
}

.logo-wrapper-green {
  background: var(--color-primary);
  border-radius: 10px;
  padding: 12px;
}

.logo-wrapper-green .partner-logo-img {
  filter: brightness(0) invert(1) !important;
}

.logo-wrapper {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.partner-logo-img {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
  filter: grayscale(20%);
  transition: filter 0.25s ease;
}

.partner-logo-card:hover .partner-logo-img {
  filter: grayscale(0%);
}

.partner-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.partner-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.partner-region {
  font-size: 0.75rem;
  color: var(--color-primary);
  font-weight: 500;
  background: var(--color-background-light);
  padding: 2px 10px;
  border-radius: 20px;
}

/* ── Responsive ───────────────────────────────────── */
@media (max-width: 768px) {
  .partners-logo-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 18px;
  }

  .logo-wrapper {
    height: 80px;
  }

  .partner-logo-img {
    max-height: 80px;
  }
}

@media (max-width: 480px) {
  .partners-logo-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
